/**
 * Muscle Grenade — Popularidad de productos (solo desktop)
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;

  var STORAGE_KEY = 'mg_social_proof_off';
  var root = document.querySelector('[data-mg-proof]');
  if (!root) return;
  if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

  var catalogEl = document.getElementById('mg-proof-catalog');
  var catalog = [];
  try {
    catalog = JSON.parse(catalogEl ? catalogEl.textContent : '[]');
  } catch (e) {
    return;
  }
  if (!catalog.length) return;

  var NAMES = [
    'María R.', 'Carlos V.', 'Diego M.', 'Camila S.', 'Jorge P.', 'Valentina L.',
    'Andrés K.', 'Fernanda T.', 'Sebastián N.', 'Daniela H.', 'Felipe A.', 'Constanza G.',
    'Matías O.', 'Javiera C.', 'Rodrigo B.', 'Paula F.', 'Ignacio D.', 'Catalina M.'
  ];

  var CITIES = [
    'Santiago', 'Providencia', 'Las Condes', 'Ñuñoa', 'La Florida', 'Maipú',
    'Vitacura', 'Valparaíso', 'Viña del Mar', 'Concepción', 'La Serena', 'Rancagua',
    'Puente Alto', 'San Bernardo', 'Antofagasta'
  ];

  var TIMES = [
    'Ahora mismo',
    'Hace unos segundos',
    'Hace 1 minuto',
    'Hace 2 minutos',
    'Hace 3 minutos',
    'Hace 5 minutos',
    'Hace 8 minutos'
  ];

  var link = root.querySelector('[data-mg-proof-link]');
  var lineEl = root.querySelector('[data-mg-proof-line]');
  var productEl = root.querySelector('[data-mg-proof-product]');
  var timeEl = root.querySelector('[data-mg-proof-time]');
  var imgWrap = root.querySelector('[data-mg-proof-img-wrap]');
  var imgEl = root.querySelector('[data-mg-proof-img]');
  var closeBtn = root.querySelector('[data-mg-proof-close]');

  var visible = false;
  var hideTimer = null;
  var loopTimer = null;
  var lastIndex = -1;

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function pickProduct() {
    var idx;
    do {
      idx = Math.floor(Math.random() * catalog.length);
    } while (catalog.length > 1 && idx === lastIndex);
    lastIndex = idx;
    return catalog[idx];
  }

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function showToast() {
    if (document.hidden) return;
    if (document.querySelector('cart-drawer[open], .cart-drawer.active')) return;

    var item = pickProduct();
    var city = pick(CITIES);
    var time = pick(TIMES);

    lineEl.innerHTML = '<strong>Popular hoy</strong> en ' + city;
    productEl.textContent = item.title;
    timeEl.textContent = time;
    link.href = item.url;

    if (item.image) {
      imgEl.src = item.image;
      imgEl.alt = item.title;
      imgWrap.hidden = false;
    } else {
      imgWrap.hidden = true;
    }

    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-visible');
    });
    visible = true;

    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, rand(4500, 6500));
  }

  function hideToast() {
    root.classList.remove('is-visible');
    visible = false;
    hideTimer = setTimeout(function () {
      if (!visible) root.hidden = true;
    }, 400);
  }

  function scheduleNext() {
    clearTimeout(loopTimer);
    loopTimer = setTimeout(function () {
      showToast();
      scheduleNext();
    }, rand(22000, 42000));
  }

  closeBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    sessionStorage.setItem(STORAGE_KEY, '1');
    clearTimeout(hideTimer);
    clearTimeout(loopTimer);
    hideToast();
    root.hidden = true;
  });

  link.addEventListener('click', function () {
    clearTimeout(hideTimer);
    hideToast();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden && visible) hideToast();
  });

  setTimeout(function () {
    showToast();
    scheduleNext();
  }, rand(8000, 14000));
})();